import * as React from 'react';

import { Box, Typography } from '@mui/material';

import { ParameterMetadata, ParameterType, PrimitiveType } from '../../../../api/api';
import { ExpressionModel } from '../../Models/ExpressionModel';
import { IVariableScope } from '../../Models/VariableScopes/IVariableScope';
import ExpressionPlaceholder from './ExpressionPlaceholder';

const MAP_IF_PARAMETER_METADATA: ParameterMetadata = {
	name: 'MapIf',
	displayName: 'Map If',
	type: ParameterType.Expression,
	categories: [],
	expectedType: { type: PrimitiveType.Boolean },
	order: 0,
	isCollection: false,
	isRequired: false,
} as ParameterMetadata;

type MapIfExpressionControlProps = {
	expression: ExpressionModel | undefined;
	onExpressionChange: (expression: ExpressionModel | undefined) => void;
	variableScope: IVariableScope | undefined;
};

export default function MapIfExpressionControl({ expression, onExpressionChange, variableScope }: MapIfExpressionControlProps) {
	return (
		<Box sx={{ mb: 1 }}>
			<Typography variant="body2" sx={{ mb: 0.5, fontWeight: 500 }}>
				Map If
			</Typography>
			<ExpressionPlaceholder
				variableScope={variableScope}
				parameterMetadata={MAP_IF_PARAMETER_METADATA}
				parameterEnum={undefined}
				expression={expression}
				onExpressionChange={onExpressionChange}
				isEditable={true}
				allowedResultTypes={[PrimitiveType.Boolean]}
			/>
		</Box>
	);
}
